/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pt_LeadInputs */

const en_cp_pt_lead = /** @type {(inputs: Cp_Pt_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Lead (student lead, free)`)
};

const id_cp_pt_lead = /** @type {(inputs: Cp_Pt_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Lead (mahasiswa penggerak, gratis)`)
};

/**
* | output |
* | --- |
* | "Campus Lead (student lead, free)" |
*
* @param {Cp_Pt_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pt_lead = /** @type {((inputs?: Cp_Pt_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pt_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pt_lead(inputs)
	return en_cp_pt_lead(inputs)
});